import { DateRangeFilter } from '../../../ui';
import { formatUtc, todayISO } from '../../../../utils/datetime';

const muted = 'text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor';

const granularities = ['daily', 'weekly', 'monthly', 'yearly', 'custom'];

export const PeriodControls = ({ params, onChange }) => (
  <div className="flex flex-wrap items-center gap-2">
    <select
      className="form-select form-select-sm w-auto capitalize"
      aria-label="Period granularity"
      value={params.granularity}
      onChange={(event) => onChange({ granularity: event.target.value })}
    >
      {granularities.map((granularity) => (
        <option key={granularity} value={granularity} className="capitalize">
          {granularity}
        </option>
      ))}
    </select>

    {params.granularity === 'custom' ? (
      <DateRangeFilter
        from={params.from}
        to={params.to}
        onFromChange={(from) => onChange({ from })}
        onToChange={(to) => onChange({ to })}
      />
    ) : (
      <input
        type="date"
        className="form-control form-control-sm w-auto"
        aria-label="Date within period"
        value={params.date}
        max={todayISO()}
        onChange={(event) => onChange({ date: event.target.value })}
      />
    )}
  </div>
);

export const PeriodCaption = ({ period }) =>
  period ? (
    <p className={`mb-2 text-sm ${muted}`}>
      {period.label} · {formatUtc(period.start_date, { withTime: false })} to{' '}
      {formatUtc(period.end_date, { withTime: false })} · {period.days} days · {period.timezone}
      {period.previous && ` · compared with ${period.previous.label}`}
    </p>
  ) : null;
